import React, {useEffect, useRef, useState} from 'react';
import {Route, Routes, Navigate, useLocation} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';
import OrganizationSettings from '@/views/organization-settings/OrganizationSettings';
import BrandsView from '@/views/organization-settings/brands/BrandsView';
import EmberIframe from '@/components/ember-iframe';
import useSetEmberIframeStyles from '@/hooks/use-set-ember-iframe-styles';
import useEmberIframeStyleStore from '@/stores/emberIframeStyleStore';

// Page top padding (24) + tab nav min-height (50) + content gap (24).
// Keep in sync with OrganizationSettings.module.scss.
// Temporary: only needed while Users / Plan & Billing / Purchase History
// still render in the Ember iframe. Remove this and the effect below
// once those tabs are ported to React.
const TAB_NAV_RESERVED_HEIGHT = 98;

function OrganizationSettingsRoutes() {
  const location = useLocation();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const emberIframeRef = useRef<HTMLIFrameElement>(null);
  const emberIframeStyleState = useEmberIframeStyleStore();

  useSetEmberIframeStyles(emberIframeRef, iframeLoaded, location);

  // Push the Ember main content area below the React tab nav so the
  // tabs and Ember content don't overlap on Ember sub-routes.
  useEffect(() => {
    const protectedMain =
      emberIframeRef.current?.contentDocument?.querySelector(
        '.protected__main'
      ) as HTMLElement | null;
    if (!protectedMain) return undefined;
    protectedMain.style.paddingTop = `${TAB_NAV_RESERVED_HEIGHT}px`;
    return () => {
      protectedMain.style.paddingTop = '';
    };
  }, [iframeLoaded, location, emberIframeStyleState]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <OrganizationSettings basePath={ROUTES.ORGANIZATION_SETTINGS} />
        }
      >
        <Route
          index
          element={<Navigate to={`brands${location.search}`} replace />}
        />
        <Route path="brands" element={<BrandsView />} />
        <Route
          path="*"
          element={
            <EmberIframe
              iframeRef={emberIframeRef}
              setIframeLoaded={setIframeLoaded}
            />
          }
        />
      </Route>
    </Routes>
  );
}

export default OrganizationSettingsRoutes;
